import { render, staticRenderFns } from "./SrnMatchStatusBar.vue?vue&type=template&id=52ff9b9e&scoped=true&"
import script from "./SrnMatchStatusBar.vue?vue&type=script&lang=js&"
export * from "./SrnMatchStatusBar.vue?vue&type=script&lang=js&"
import style0 from "./SrnMatchStatusBar.vue?vue&type=style&index=0&id=52ff9b9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ff9b9e",
  null
  
)

export default component.exports